export const miscFormConfig = {
  MiscItemForm: {
    title: 'New Misc item.',
    fields: ['name', 'cost', 'discount'],
    styles: {
      // formColumns: 2,
      labelBold: true,
    },
  },
  fields: {
    name: {
      label: 'Name',
      placeholder: 'Name',
      shouldRenderFieldLabel: false,
    },
    cost: {
      label: 'Price',
      placeholder: '00.00',
      component: 'forms.DecimalField',
      shouldRenderFieldLabel: false,
    },
    discount: {
      label: 'Discount',
      placeholder: '10 %',
      component: 'forms.TextField',
      suffixValue: '%',
      fieldStore: 'forms.IntegerFieldStore',
      minVal: 0,
      maxVal: 100,
      shouldRenderFieldLabel: false,
    },
  },
};
